import Footer from '../../component/Other/Footer';
import Navbar from '../../component/Other/Navbar';
import Head from '../../component/Section/Head';
import React, { useContext } from 'react';
import { useAsync } from 'react-use';
import { AppContext } from '../../core/Contexts/AppContext';
import { getTopNews } from '../../core/services/news';
import { getImageFullPath } from '../../core';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import DOMPurify from 'dompurify';
import { useLocation } from 'react-router-dom';
import Breadcrumbs from '../../component/Other/Breadcrumbs';

export const Layout = ({ children }) => {
  const location = useLocation();
  const { title, headerType, image } = useContext(AppContext);

  const settings = {
    dots: true,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 4000,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  const news = useAsync(getTopNews, []);

  return (
    <>
      <div className='overflow-hidden'>
        <div className='position-relative'>
          {headerType === 1 && (
            <img src={image} className='images__wrap-head' alt='' />
          )}
          {headerType === 2 && (
            <img
              src='../../images/hero-images/pattern-bg-optimized.jpg'
              className='images__wrap-head'
              alt=''
            />
          )}
          {/* <div className='wrapper__bg-head'></div> */}
          {location.pathname !== '/' && (
            <div className='wrapper__bg-head'></div>
          )}
          <Navbar />
          {headerType === 1 && <Head title={title} />}
          {headerType === 2 && (
            <Slider {...settings} className='container'>
              {!news.loading &&
                news.value.map((newsItem, index) => (
                  <div key={index} className='slider-container'>
                    <div className='new-left'>
                      <img
                        src={getImageFullPath(`uploads/news/${newsItem.img}`)}
                        alt={newsItem.title}
                      />
                    </div>
                    <div className='new-right'>
                      <h1 className='margin-0 semi-bold font__size--21 text__16-1024 color__black text-uppercase'>
                        {newsItem.title}
                      </h1>
                      <p
                        className='color__black font__size--15 padding-tb text__14-1024 description-clamp'
                        dangerouslySetInnerHTML={{
                          __html: DOMPurify.sanitize(
                            newsItem.desc
                              // Replace any <p ...> with <div> to avoid UA paragraph spacing
                              .replace(/<p[^>]*>/gi, '<div>')
                              .replace(/<\/p>/gi, '</div>'),
                            { FORBID_ATTR: ['style', 'align'] } // remove inline justification
                          ),
                        }}
                      />
                      <a
                        href={`/news/detail/${newsItem.id}`}
                        className='btn-shape semi-bold font__size--16 text__14-1024 hero-button no__opacity'
                      >
                        ვრცლად
                      </a>
                    </div>
                  </div>
                ))}
            </Slider>
          )}
        </div>

        <Breadcrumbs />
        {children}
        <Footer />
      </div>
    </>
  );
};
